// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__hm3nG","requiredAsterisk":"Info_requiredAsterisk__ge8pF"};